import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseDialogDirective } from '../../base/base-dialog.directive';
import { DialogWrapperComponent } from '../../wrappers/dialog-wrapper/dialog-wrapper.component';
import { ButtonSize, ButtonStyle } from '../../../enums/button.enum';
import { ButtonComponent } from '../../button/button.component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  imports: [DialogWrapperComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent extends BaseDialogDirective {
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonStyle = ButtonStyle;
}
